const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManagementTwoTone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C7.589 2 4 5.589 4 10C4 14.411 7.589 18 12 18C16.411 18 20 14.411 20 10C20 5.589 16.411 2 12 2ZM12 16C8.692 16 6 13.308 6 10C6 6.692 8.692 4 12 4C15.308 4 18 6.692 18 10C18 13.308 15.308 16 12 16ZM12 6C10.346 6 9 7.346 9 9C9 10.654 10.346 12 12 12C13.654 12 15 10.654 15 9C15 7.346 13.654 6 12 6ZM12 10C11.448 10 11 9.552 11 9C11 8.448 11.448 8 12 8C12.552 8 13 8.448 13 9C13 9.552 12.552 10 12 10Z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6C10.346 6 9 7.346 9 9C9 10.654 10.346 12 12 12C13.654 12 15 10.654 15 9C15 7.346 13.654 6 12 6ZM12 10C11.448 10 11 9.552 11 9C11 8.448 11.448 8 12 8C12.552 8 13 8.448 13 9C13 9.552 12.552 10 12 10Z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 14C9.33 14 6.999 15.673 6.999 18.999C6.999 19.552 7.447 20 7.999 20C8.552 20 8.999 19.552 8.999 18.999C8.999 17.342 10.342 16 12 16C13.658 16 15 17.342 15 18.999C15 19.552 15.448 20 16 20C16.552 20 17 19.552 17 18.999C17 15.673 14.67 14 12 14Z",
    fill: props.color
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagementTwoTone);
export default __webpack_public_path__ + "static/media/ManagementTwoTone.11859b4f6a4ddc78abf917ff9c0ee401.svg";
export { ForwardRef as ReactComponent };